<template>
    <div class="header-block">
        <div class="header-block--left">
            <h1 class="header-block--title">
                John Horjus
            </h1>
            <p class="header-block--undertitle">
                Freelance creative/director
            </p>
        </div>
        <div class="header-block--right">
            <a v-on:click="toggleOverlay">
                Contact
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'HeaderBlock',
    mounted() {

    },
    methods: {
        toggleOverlay: function () {
            this.$parent.toggleOverlay();
        }
    }
}
</script>



// WEBPACK FOOTER //
// HeaderBlock.vue?448f33c2